<template>
    <div>
        <template v-if="!question_code">
            <b-container class="p-0">
                <div class="py-5 text-center bgray-200 rounded">질문 리스트에서 편집할 질문을 선택해주세요.</div>
            </b-container>
        </template>

        <template v-else>
            <b-container class="px-0">
                <div
                    class="d-flex justify-content-between align-items-center border-bottom border-color-gray-300 f-120 fw-800 pt-2 mb-2">
                    <span v-show="!is_question_subs_fully_loaded" class="gray-400">
                        (불러오는중)
                    </span>
                    <span v-show="is_question_subs_fully_loaded">
                        {{ question_name }} {{ question_code }}
                    </span>
                    <div>
                        <b-button size="sm" class="mb-1" @click="openSubOrderChangeModal">문항 순서 변경</b-button>
                    </div>
                </div>

                <b-card
                    no-body
                    class="border border-color-gray-300 border-style-dashed mb-4 p-1"
                    @click="openModifyModal('info_box')"
                >
                    <b-card-text
                        v-if="!isFieldEmpty(question_infobox)"
                        class="small"
                    >
                        <span v-show="$i18n.locale === 'ko'"> {{ question_infobox }} </span>
                        <span v-show="$i18n.locale !== 'ko'"> {{ question_infobox_foreign }} </span>
                    </b-card-text>
                    <b-card-text v-else>
                        클릭하여 질문의 배경 정보를 입력해 주세요(Click)
                    </b-card-text>
                </b-card>

                <template v-if="is_question_subs_fully_loaded === false && (question_subs && question_subs.length)">
                    <div class="d-flex justify-content-center align-items-center bgray-200 rounded py-5">
                        <h4 class="font-weight-normal">
                            <b-spinner class="mr-3"/>
                            <span>질문의 세부문항을 불러오고 있습니다.</span>
                        </h4>
                    </div>
                </template>


                <!-- sortable -->
                <div v-for="(sub, index) in question_subs"
                     :key="sub.index"
                     class="d-flex mb-5"
                >
                    <div
                        class="position-relative border border-color-gray-300 border-style-dashed cursor p-2"
                        :style="score_not_defined === false ? 'width: 60%; min-width: 60%;' : 'width: 100%;'"
                    >
                        <div v-if="sub.sub_type" @click.stop="openModifyModal('sub_component', index)">
                            <sub-component
                                :sub_type="sub.sub_type"
                                :item="sub"
                                :preview="true"
                                :view_pipe_line="false"
                                :is_disabled_by_parent="true"
                                :is_edit_page="true"
                                @update-contents="handleUpdateContents(index)"
                            />
                        </div>
                        <div v-else
                             class="pl-2"
                             @click="openModifyModal('sub_component', index)"
                        >
                            클릭하여 세부 질문을 정의해 주세요(Click)
                        </div>
                        <div class="position-absolute" style="top: 0; right:0;">
                            <b-button
                                variant="red"
                                size="sm"
                                class=""
                                @click="openDeleteModal(sub.sub_code)"
                            >
                                <fa icon="trash-alt"></fa>
                            </b-button>
                        </div>
                    </div>

                    <template v-if="sub.sub_type">
                        <div class="pl-3 d-none d-lg-block"
                             style="width: 40%; min-width: 40%;"
                        >
                            <b-collapse
                                :id="'method' + sub.sub_code"
                                class="bgray-100"
                                visible
                            >
                                <editing-scoring-method-v2
                                    :sub_code="sub.sub_code"
                                    :sub_type="sub.sub_type"
                                    :read_only="true"
                                    @score_not_defined="handleScoreNotDefined"
                                />
                            </b-collapse>
                        </div>
                    </template>
                </div>
            </b-container>
        </template>

        <template v-if="question_code">
            <div class="text-right pt-5">
                <b-button variant="blue" size="sm"
                          :disabled="is_empty_template_meta"
                          @click="addSub"
                >
                    <fa icon="plus" class="mr-1"></fa>
                    새문항
                </b-button>
            </div>
        </template>

        <!-- sub component 생성/수정하기 모달 -->
        <b-modal
            id="modify-modal"
            ref="modify-modal"
            title="수정하기"
            hide-footer
            scrollable
            :size="use_v2 ? 'xl' : undefined"
            :dialog-class="use_v2 ? 'qm-v2-dialog' : ''"
            @hide="handleHide"
            @hidden="handleHidden"
        >
            <template v-if="modal_mode === 'info_box'">
                <div class="fw-400 p-2 text-left"> Infobox 수정</div>
                <p class="mb-1">※ 배경정보의 번역 편집은 번역편집 화면에서 하셔야 합니다.</p>
                <p>※ <strong>1. 질문 리스트 생성</strong> 에서 <strong>편집모드 버튼</strong> 클릭 후 하단 <strong>번역 버튼</strong> 클릭.</p>
                <b-form-textarea v-model="question_infobox" class="p-2" rows="6"></b-form-textarea>
                <div class="mt-3 mb-3 mr-3 text-right">
                    <b-btn variant="dark" :disabled="is_empty_template_meta"
                           @click="hideModal"
                    >
                        취소
                    </b-btn>
                    <b-btn class="ml-2" variant="blue" :disabled="is_empty_template_meta"
                           @click="handleOK"
                    >
                        저장
                    </b-btn>
                </div>
            </template>
            <template v-else-if="idx === -1 && modal_mode === 'sub_component'">
                <div style="min-height: 50vh">
                    <editing-others :idx="idx" @click-cancel="hideModal()" @click-save="handleOK"/>
                </div>
            </template>
            <template v-else-if="idx > -1 && modal_mode === 'sub_component'">
                <div style="min-height: 50vh">
                    <template v-if="!question_subs[idx].sub_code">
                        <editing-others :idx="idx" @click-cancel="hideModal()" @click-save="handleOK"/>
                    </template>
                    <template v-else>
                        <b-card no-body>
                            <!-- 지원 타입은 v2 한 화면(구조·설정·채점·번역)이 기본. 스위치로 구 편집기(Editing/Scoring/번역 탭)로 돌아갈 수 있다. -->
                            <div v-if="v2_supported" class="px-3 pt-2 text-right">
                                <b-form-checkbox v-model="use_legacy_editor" switch size="sm" inline>구 편집기로 열기</b-form-checkbox>
                            </div>
                            <!-- :key — 스위치를 바꾸면 탭을 다시 만들어 첫 탭 활성·lazy 재마운트를 보장한다 -->
                            <b-tabs :key="String(use_v2)" card content-class="p-3" active-nav-item-class="text-info">
                                <b-tab v-if="use_v2" no-body title="편집 (v2)" lazy>
                                    <sv2-editor
                                        :code="question_subs[idx].sub_code"
                                        @saved="handleV2Saved"
                                        @dirty="updatePreventHideModifyModal"
                                        @cancel="handleV2Cancel"
                                    />
                                </b-tab>
                                <b-tab v-if="!use_v2" no-body title="Editing" lazy>
                                    <editing-sub-component
                                        :label="question_subs[idx].label"
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        @click-save="handleOK"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab v-if="!use_v2" no-body title="Scoring" lazy>
                                    <editing-scoring-method-v2
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        @on-prevent-modify-modal="updatePreventHideModifyModal"
                                        @scoring_method_saved="handleOK"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab no-body title="Pipeline" lazy>
                                    <editing-pipeline
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab no-body title="Figure" lazy>
                                    <editing-figure-definition
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab v-if="!use_v2" no-body title="번역" lazy>
                                    <editing-translation
                                        :sub_data="question_subs[idx]"
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab no-body title="Parser" lazy>
                                    <editingSubParserPicker
                                        :sub_data="question_subs[idx]"
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        :sub_data_contents="question_subs[idx].sub_data_contents"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                                <b-tab no-body title="Criteria Dictionary" lazy>
                                    <EditingCriteriaDictionary
                                        :sub_data="question_subs[idx]"
                                        :sub_code="question_subs[idx].sub_code"
                                        :sub_type="question_subs[idx].sub_type"
                                        :sub_data_contents="question_subs[idx].sub_data_contents"
                                        @click-cancel="hideModal()"
                                    />
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </template>
                </div>
            </template>
        </b-modal>

        <!-- 삭제경고 Modal -->
        <b-modal ref="delete-modal" header-text-variant="danger" title="경고" @ok="unlinkSub(delete_target_code)">
            <p> 진행할 경우 선택한 질문이 사라집니다. '검색하여 넣기'를 통해 다시 추가할 수 있습니다.</p>
            <p> 계속 하시겠습니까? </p>
        </b-modal>
        <SubOrderChangeModal :subs="question_subs"
                             :question_code="question_code"
                             :question_name="question_name"
                             @subsOrderChanged="readQuestionContent"
        />

    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import subComponent from '@core_components/client/components/subs/SubComponent.vue';
import editingPipeline from '@core_components/admin/components/subs/EditingPipeline';
import editingFigureDefinition from '@core_components/admin/components/subs/EditingFigureDefinition';
import editingTranslation from '@core_components/admin/components/subs/EditingTranslation';
import editingSubParserPicker from '@core_components/admin/components/subs/EditingSubParserPicker';
import EditingCriteriaDictionary from '@core_components/admin/components/subs/EditingCriteriaDictionary';
import editingSubComponent from '@core_components/admin/components/subs/editing/EditingSubComponent';
import EditingOthers from '@core_components/admin/components/subs/editing/EditingOthers';
import SubOrderChangeModal from '@core/components/admin/components/subs/SubOrderChangeModal.vue';
import EditingScoringMethodV2 from '@/components/editingTemplate/EditingScoringMethod_v2.vue';
// v2 편집기(구조·문항 설정·채점 기준·번역 한 화면). 지원 타입이면 기본, 아니면 구 탭 그대로.
import Sv2Editor from '@/components/structureV2/Sv2Editor.vue';
import {SUPPORTED_SUB_TYPES} from '@core_utils/subComponent/structure-tree.js';
import tempEvCode from './temp_ev_code.json';
import {waitTime} from '@shared/utils/common';

export default {
    name: 'QuestionMasterV2',
    props: {},
    components: {
        Sv2Editor,
        EditingScoringMethodV2,
        SubOrderChangeModal,
        subComponent,
        editingSubComponent,
        editingPipeline,
        EditingOthers,
        editingFigureDefinition,
        editingTranslation,
        editingSubParserPicker,
        EditingCriteriaDictionary
    },
    data() {
        return {
            is_disabled: false,
            modal_mode: false,
            idx: -1,
            delete_target_code: '',
            // show_sub_component: true,
            // show_scoring_method: false,
            // show_pipeline: false,
            // show_figure_definition: false, 
            score_not_defined: false,
            is_prevent_hide_modifyModal: false,
            // v2 → 구 편집기 전환 스위치. 설정이 아니라 전환기 안전망이라 모달을 열 때마다 리셋한다.
            use_legacy_editor: false,
            // v2 에서 한 번이라도 저장했으면 모달이 닫힌 뒤 전체 재조회(목록의 채점 패널까지 리마운트)
            saved_in_modal: false
        };
    },
    computed: {
        ...mapState(['is_question_subs_loaded', 'template_tree']),
        ...mapState('questions', ['subs_loaded']),
        question_composition() {
            return this.$store.getters.getQuestionComposition;
        },
        question_code() {
            return this.question_composition.question_code || this.$route.query.question_id;
        },
        question_name() {
            const {question_name, question_name_e, question_name_c} = this.question_composition;
            switch (this.$i18n.locale) {
            case 'ko':
                return question_name;
            case 'ca':
                return question_name_c;
            default:
                return question_name_e;
            }
        },
        question_subs() {
            return JSON.parse(JSON.stringify(this.$store.state.question_subs));
        },
        /** 지금 고른 문항을 v2 가 변환할 수 있는가 (file_URL2 등은 전용 변환이 없어 구 편집기) */
        v2_supported() {
            const s = this.idx > -1 && this.question_subs[this.idx];
            return !!(s && s.sub_code && SUPPORTED_SUB_TYPES.includes(s.sub_type));
        },
        use_v2() {
            return this.v2_supported && !this.use_legacy_editor;
        },
        question_infobox: {
            get() {
                return this.question_composition.question_infobox;
            },
            set(_newValue) {
                this.$store.commit('update_question_infobox', _newValue);
            }
        },
        question_infobox_foreign() {
            const {question_infobox_e, question_infobox_c} = this.question_composition;
            switch (this.$i18n.locale) {
            case 'ca':
                return question_infobox_c;
            default:
                return question_infobox_e;
            }
        },
        is_question_subs_fully_loaded() {
            return this.is_question_subs_loaded;
        },
        is_empty_template_meta() {
            return this.isFieldEmpty(this.template_tree.template_name) || this.isFieldEmpty(this.template_tree.template_type);
        }
    },
    watch: {
        '$route.query.question_id': {
            async handler(_current_id) {
                if (_current_id) {
                    await this.readQuestionContent(_current_id);
                } else {
                    this.$store.commit('update_is_question_subs_loaded', true);
                }
            }
        }
    },
    async created() {
        const _question_code = this.$route.query.question_id;
        await this.fetchEvCode();
        if (_question_code) {
            await this.readQuestionContent(_question_code);
        } else {
            this.$store.commit('update_is_question_subs_loaded', true);
        }
    },
    beforeDestroy() {
        this.$store.commit('update_question_composition', null);
        this.$store.commit('reset_question_subs');
    },
    methods: {
        ...mapActions('evaluations', ['fetchEvCode']),
        async readQuestionContent(question_code) {
            this.$store.commit('update_is_question_subs_loaded', false);
            this.$store.commit('update_question_composition', null);
            this.$store.commit('reset_question_subs');
            await this.$store.dispatch('readQuestionComposition', question_code);
            await this.$store.dispatch('readQuestionSubsInit');
            this.$store.commit('update_is_question_subs_loaded', true);
        },
        async saveQuestionComposition() {
            await this.$store.dispatch('saveQuestionComposition');
            this.$emit('toast-success', '성공', '질문 내용 변경사항을 저장하였습니다.');
        },
        async unlinkSub(delete_target_code) {
            await this.$store.dispatch('unlinkSub', {sub_code: delete_target_code});
            this.$emit('toast-success', '성공', '질문 내용 변경사항을 저장하였습니다.');
        },
        async handleOK() {
            this.idx = -1;
            this.modal_mode = false;
            this.$refs['modify-modal'].hide();
        },
        hideModal() {
            this.idx = -1;
            this.modal_mode = false;
            // 닫힘 방지 플래그는 이 모달 세션의 것. 남겨두면 다음에 연 문항에서 아무것도 안 고쳐도 confirm 이 뜬다.
            this.is_prevent_hide_modifyModal = false;
            this.$refs['modify-modal'].hide();
        },
        /** v2 저장바의 '닫기' — ESC/X 와 같은 규칙: 저장 안 한 변경이 있으면 묻고 닫는다 */
        handleV2Cancel() {
            if (this.is_prevent_hide_modifyModal &&
                !confirm('수정한 데이터를 저장하지 않고 닫으면 데이터가 유실될 수 있습니다. 그래도 닫으시겠습니까?')) return;
            this.hideModal();
        },
        openDeleteModal(delete_target_code) {
            this.delete_target_code = delete_target_code;
            this.$refs['delete-modal'].show();
        },
        handleScoreNotDefined() {
            this.score_not_defined = true;
        },
        addSub() {
            if (!this.question_code) {
                return alert('질문 리스트를 먼저 만들어 주세요.');
            }

            this.openModifyModal('sub_component');
        },
        openModifyModal(mode, index = -1) {
            this.use_legacy_editor = false;
            this.saved_in_modal = false;
            this.is_prevent_hide_modifyModal = false;
            this.modal_mode = mode;
            this.idx = index;
            this.$refs['modify-modal'].show();
        },
        /** v2 저장 성공. 편집기는 자기 원본을 이미 재조회했고, 뒤 목록(question_subs)은 여기서 갱신한다.
         *  readQuestionSubsInit 은 배열을 비우지 않으므로 모달을 연 채 불러도 안전하다. */
        async handleV2Saved() {
            this.saved_in_modal = true;
            try {
                await this.$store.dispatch('readQuestionSubsInit');
            } catch (error) {
                // 저장은 이미 됐다. 목록만 낡은 것이니 닫을 때의 전체 재조회(handleHidden)에 맡기고 흔적만 남긴다.
                console.error('[QuestionMasterV2] v2 저장 후 목록 재조회 실패', error);
            }
        },
        /** 모달이 완전히 닫힌 뒤. 저장이 있었으면 전체 재조회 — readQuestionContent 는 목록을 비웠다 채우므로
         *  열린 상태에서 부르면 question_subs[idx] 렌더가 깨진다. 닫힌 뒤에만. */
        handleHidden() {
            if (this.saved_in_modal) {
                this.saved_in_modal = false;
                this.readQuestionContent(this.question_code);
            }
        },
        toggleDisabled(x) {
            this.is_disabled = x;
        },
        togglePreviewing() {
            this.is_previewing = !this.is_previewing;
        },
        handleHide(bvModalEvent) {
            if (bvModalEvent.trigger === 'esc' || bvModalEvent.trigger === 'backdrop' || bvModalEvent.trigger === 'headerclose') {
                if (this.is_prevent_hide_modifyModal) {
                    const _confirm_close_not_save_edited = confirm('수정한 데이터를 저장하지 않고 닫으면 데이터가 유실될 수 있습니다. 그래도 닫으시겠습니까?');
                    if (!_confirm_close_not_save_edited) {
                        bvModalEvent.preventDefault();
                        return false;
                    }
                }
            }

            this.hideModal();
        },
        updatePreventHideModifyModal(_state) {
            this.is_prevent_hide_modifyModal = _state;
        },
        openSubOrderChangeModal(){
            this.$bvModal.show('sub-order-change-modal');
        }
    }
};
</script>

<style>
/* v2 편집기 모달 — modal-xl(1140px)은 미리보기·구조·인스펙터 세 기둥에 비좁다. v2 의 미디어쿼리는
   뷰포트 기준이라 모달 폭에 반응하지 않으므로 다이얼로그 자체를 넓힌다 (SupplementReview 와 같은 방식). */
@media (min-width: 1200px) {
    .modal-dialog.qm-v2-dialog { max-width: min(1600px, calc(100vw - 2rem)); }
}
/* .bottom-blue {
    border-bottom: 1px solid var(--blue);
} */
/* .bottom-red {
    border-bottom: 1px solid var(--red);
} */

</style>
